<template>
  <div class="filter-label">
    <CheckboxLabel
      v-for="{ label, productsCount } in labels"
      :key="label"
      :label="label"
    >
      {{ _T(labelTitle[label]) }}
      <span class="filter-label__count">
        {{ productsCount }}
      </span>
    </CheckboxLabel>
  </div>
</template>

<script setup>
import CheckboxLabel from "~/modules/productCatalog/ui/components/filter/bar/CheckboxLabel.vue";

const props = defineProps({
  labels: { type: Array, required: true },
});

const labelTitle = {
  promotion: "@Promotion",
  novelty: "@Novelty",
  bestSeller: "@Top selling",
};
</script>

<style lang="scss" scoped>
.filter-label {
  @include flex-container(column, flex-start);

  border-bottom: 1px solid var(--color-sky-base);

  padding-bottom: 16px;

  @include bigMobile {
    background-color: var(--color-sky-lightest);
    border: none;
    border-radius: 16px;

    padding: 0;
  }

  &__count {
    @include font(12, 14);
    color: var(--color-sky-darker);
  }
}
</style>
